/**
 * Return True when a URL points at a Google Drive/Docs/Sheets/Slides resource.
 *
 * @example
 * isGoogleDriveContextUrl("https://docs.google.com/document/d/abc/edit");
 * // true
 *
 * @example
 * isGoogleDriveContextUrl("https://example.com/doc");
 * // false
 */
export const isGoogleDriveContextUrl = (url) => {
  const value = String(url || "").toLowerCase();
  return (
    value.includes("docs.google.com") ||
    value.includes("drive.google.com") ||
    value.includes("sheets.google.com") ||
    value.includes("slides.google.com")
  );
};

/**
 * Return True when text contains at least one Google Drive context URL.
 *
 * @example
 * hasDriveContextLinks("https://docs.google.com/document/d/abc/edit\n");
 * // true
 */
export const hasDriveContextLinks = (driveInput) =>
  String(driveInput || "")
    .split("\n")
    .map((line) => line.trim())
    .filter((line) => line.startsWith("http"))
    .some(isGoogleDriveContextUrl);

/**
 * Map performer Gmail API errors to settings-friendly copy.
 *
 * @example
 * formatPerformerGmailError("No Gmail credential linked");
 * // "Connect Gmail to save AI drafts in your mailbox."
 */
export const formatPerformerGmailError = (message) => {
  const text = String(message || "").trim();
  if (!text || text === "No Gmail credential linked") {
    return "Connect Gmail to save AI drafts in your mailbox.";
  }
  if (text === "Gmail compose scope is not granted") {
    return "Reconnect Gmail to allow saving drafts in your mailbox.";
  }
  return text;
};
